import { isEqual, random } from "seneca-common/utils/functions";
import shuffle from "seneca-common/utils/functions/random/shuffle";

import { Content, ContentSource, Toggle, TogglePosition } from "../types";

export function generateContent(source: ContentSource): Content {
  const { statement, toggles } = source;

  const validToggles = toggles.filter(t => {
    return t && t.correctToggle && t.incorrectToggle;
  });

  const shuffledToggles = shuffle(validToggles);
  const contentToggles = shuffledToggles.map(toggle => {
    const correctAnswerIndex = random(0, 1);
    const incorrectAnswerIndex = correctAnswerIndex ? 0 : 1;
    return {
      [`index${correctAnswerIndex}`]: toggle.correctToggle,
      [`index${incorrectAnswerIndex}`]: toggle.incorrectToggle,
      correctAnswer: correctAnswerIndex
    };
  }) as Toggle[];
  const correctAnswer = contentToggles.reduce((answer, toggle) => {
    answer.push(toggle.correctAnswer as TogglePosition);
    return answer;
  }, [] as TogglePosition[]);
  const initialAnswer = generateInitialAnswer(correctAnswer);

  return {
    statement,
    toggles: contentToggles,
    initialAnswer
  };
}

function generateInitialAnswer(
  correctAnswer: TogglePosition[]
): TogglePosition[] {
  if (correctAnswer.length === 0) {
    throw new Error("Can't have toggles module with no toggles");
  }

  let initialAnswer: number[] = [...correctAnswer];

  while (isEqual(initialAnswer, correctAnswer)) {
    for (let i = 0; i < correctAnswer.length; i++) {
      initialAnswer[i] = random(0, 1);
    }
  }

  return initialAnswer as TogglePosition[];
}
